import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_SIP_SETTING,
  SipSetting,
} from './sipSetting.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getSipSetting(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<SipSetting>> {
  return http.get(`${API_PATH_SIP_SETTING}/${deliveryFunctionId}`);
}

export function updateSipSetting(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SipSetting>,
): AxiosPromise<ServerResponse<SipSetting>> {

  return http.put(`${API_PATH_SIP_SETTING}/${deliveryFunctionId}`, body);
}

export function deleteSipSetting(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SipSetting>,
): AxiosPromise<ServerResponse<SipSetting>> {
  // NOTE: it was needed to wrap the body in a data field because DELETE method behhaviour
  return http.delete(`${API_PATH_SIP_SETTING}/${deliveryFunctionId}`, { data: body });
}

export function createSipSetting(
  deliveryFunctionId: string,
  body: WithAuditDetails<SipSetting>,
): AxiosPromise<ServerResponse<SipSetting>> {
  return http.post(`${API_PATH_SIP_SETTING}/${deliveryFunctionId}`, body);
}
